var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3.441l3.5-3.704v9.526L18 12.558V16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.67h11c.37 0 .67.3.67.67v9c0 .37-.3.67-.67.67H5a.67.67 0 0 1-.67-.67V7c0-.37.3-.67.67-.67",
    clipRule: "evenodd"
  })));
};
export default SvgVideo;